import type {
  AsyncActionPayload,
  AsyncActionsState,
} from "./async-actions.type";

import { atom } from "jotai";

export const asyncActionsAtom = atom<AsyncActionsState>({
  deleting: {},
  updated: {},
  failed: {},
});

export const addItemToAsyncActionsAtom = atom(
  null,
  (get, set, { type, modelKey, id }: AsyncActionPayload) => {
    const state = get(asyncActionsAtom);

    const stateType = state[type];
    const ids = stateType[modelKey] ?? [];

    if (ids.includes(id)) return;

    set(asyncActionsAtom, {
      ...state,
      [type]: { ...stateType, [modelKey]: [...ids, id] },
    });
  }
);

export const removeItemToAsyncActionsAtom = atom(
  null,
  (get, set, { type, modelKey, id }: AsyncActionPayload) => {
    const state = get(asyncActionsAtom);

    const stateType = state[type];
    const ids = stateType[modelKey] ?? [];

    if (!ids) return;

    const newIds = ids.filter((x) => x !== id);
    const { [modelKey]: _, ...rest } = stateType;

    set(asyncActionsAtom, {
      ...state,
      [type]: newIds.length ? { ...stateType, [modelKey]: newIds } : rest,
    });
  }
);
